import { render, staticRenderFns } from "./product_badges.vue?vue&type=template&id=251b222c"
import script from "./product_badges.vue?vue&type=script&lang=js"
export * from "./product_badges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('251b222c')) {
      api.createRecord('251b222c', component.options)
    } else {
      api.reload('251b222c', component.options)
    }
    module.hot.accept("./product_badges.vue?vue&type=template&id=251b222c", function () {
      api.rerender('251b222c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/product_badges.vue"
export default component.exports